/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumesubscriptionconfirmtitle3Inputs */

const en_resumesubscriptionconfirmtitle3 = /** @type {(inputs: Resumesubscriptionconfirmtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume your subscription?`)
};

const de_resumesubscriptionconfirmtitle3 = /** @type {(inputs: Resumesubscriptionconfirmtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement fortsetzen?`)
};

/**
* | output |
* | --- |
* | "Resume your subscription?" |
*
* @param {Resumesubscriptionconfirmtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const resumesubscriptionconfirmtitle3 = /** @type {((inputs?: Resumesubscriptionconfirmtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumesubscriptionconfirmtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resumesubscriptionconfirmtitle3(inputs)
	return de_resumesubscriptionconfirmtitle3(inputs)
});
export { resumesubscriptionconfirmtitle3 as "resumeSubscriptionConfirmTitle" }